import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Button,
  BUTTON_SIZE_LG,
  BUTTON_VARIANT_PRIMARY,
  PageHeader
} from 'mailup-web-components'

import { notifyParent } from 'mailup-react-helpers'

import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { saveMessageCallback } from '../recoil/callbacks/callbacks'
import { canSaveState } from '../recoil/state/message'
import { pageState } from '../recoil/state/page'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id } = useParams()
  const [redirectUrl] = useRedirectorUrl()

  const { title } = useRecoilValue(pageState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailOverview', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Saved' }),
      'data-mu-test': 'breadcrumb-item__saved',
      className: 'test-breadcrumb-item__saved',
      url: '#',
      onClick: () => {
        history.push('/messages/email/saved')
      }
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Overview' }),
      'data-mu-test': 'breadcrumb-item__overview',
      className: 'test-breadcrumb-item__overview'
    }
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Overview' }),
      'data-mu-test': 'topmenu-item__overview',
      className: 'test-topmenu-item__overview',
      isActive: true,
      onClick: () => null
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.EmailCheckup' }),
      'data-mu-test': 'topmenu-item__email-checkup',
      className: 'test-topmenu-item__email-checkup',
      isActive: false,
      onClick: () => history.push(`/messages/email/${id}/checkup/summary`)
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Previews' }),
      'data-mu-test': 'topmenu-item__previews',
      className: 'test-topmenu-item__previews',
      isActive: false,
      onClick: () => {
        history.push(`/messages/email/${id}/previews`)
      }
    }
  ]

  const ControlsComponent = () => {
    const canSave = useRecoilValue(canSaveState)
    const save = useRecoilCallback(saveMessageCallback, [])
    const handleSaveClick = e => {
      save()
    }

    return (
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        size={BUTTON_SIZE_LG}
        className='test-buttonSave'
        data-mu-test='cta-save'
        disabled={!canSave}
        onClick={handleSaveClick}
      >
        {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
      </Button>
    )
  }

  return (
    <PageHeader
      title={title}
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      ControlsComponent={ControlsComponent}
      loading={!title}
    />
  )
}

export default Header
